import React from 'react';
import './ModernBlocks.css';

const HeroBlock = ({ data }) => {
  return (
    <section 
      className="hero-section"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${data.background})`
      }}
    >
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            {data.title}
          </h1>
          <p className="hero-subtitle">
            {data.subtitle}
          </p>
          <div className="hero-buttons">
            {data.buttons.map((button, index) => (
              <button
                key={index}
                className={`hero-button ${button.variant}`}
                onClick={() => window.location.href = button.link}
              >
                {button.text}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', bottom: '2rem', left: '50%', transform: 'translateX(-50%)' }}>
        <div style={{ animation: 'bounce 2s infinite' }}>
          <svg style={{ width: '1.5rem', height: '1.5rem', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default HeroBlock; 